module.exports = __webpack_public_path__ + "static/media/ic_default_image.cff87c91.jpg";